import React, { Dispatch, useCallback, useEffect, useState } from "react"
import { useDispatch } from "react-redux";
import config from "../../config/config";
import { setCurrentPage } from "../../store/actionCreators";
import axios from 'axios';
import Markdown from "markdown-to-jsx";
import { useTranslation } from "react-i18next";

/**
 * Cookies page
 * 
 */

export interface ICMSPage {
    id: number
    attributes: ICMSPageAttributes
} 

export interface ICMSPageAttributes {
    title: string
    body: string
} 

function Cookies() {  

    const dispatch: Dispatch<any> = useDispatch();

    const { t } = useTranslation();

    const setPageName = useCallback((currentPage: string) => dispatch(setCurrentPage(currentPage)), [dispatch]);
    setPageName(t("Cookie Policy"));

    const [content, setContent] = useState<ICMSPage>();

    useEffect(() => {
        fetchCategory();
    }, [])

    async function fetchCategory() {        
        axios.get(`${config.contentServerURL}/api/pages?filters[category][$eq]=cookies`).then(resp => { // Strapi v4 query format
            setContent(resp.data.data[0]);
        }, error => {
            console.log("Failed to get cookie policy", error)
        });      
    }    

    return (
        <div className="terms container">
            {content ? <Markdown>{content.attributes.body}</Markdown> : null}
        </div>
    )
}

export default Cookies
